// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module--root--3QZkY","time":"styles-module--time--3ueGr","link":"styles-module--link--Zl1H9"};